<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" :search-condition="searchCondition" :search-buttons="searchButtons"
        :fuzzySearchKey="'operatorName'" :fuzzySearchPlaceholder="$t('message.permission.name')"
        router-name="/account/permission/operator">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getOperatorList" ref="table"
        router-name="/account/permission/operator">
        <template #roleName="{ row }">
          <div class="role-name-box">
            <span>{{ !row.roleName && row.isAdmin ? $t('message.permission.admin') : row.roleName }}</span>
            <!-- <span v-if="!row.isAdmin">
                          <el-popover
                            :visible-arrow="false"
                            popper-class="permission-popover"
                            trigger="click"
                            @show="handleShowPermission(row.roleId)">
                            <PermissionPopover :info="permissionInfo"></PermissionPopover>
                            <i class="iconfont icon-wenhao" slot="reference"></i>
                          </el-popover>
                        </span> -->
          </div>
        </template>
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
    <validation-modal ref="resetPasswordModal" :titleText="$t('message.permission.resetPassword')"
      :validation-condition="resetPasswordCondition" :default-function="resetPassword"
      @refresh="refreshTable"></validation-modal>
    <!-- 编辑操作员 -->
    <validation-modal ref="editOperatorModal" :titleText="$t('message.permission.editOperator')"
      :validation-condition="editOperatorCondition" :default-function="onUpdateOperator" @refresh="refreshTable"
      @close="handleEditModalClose">
      <template v-if="showPhoneNumber">
        <div class="margin-bottom-20">
          <p class="edit-form-label-title">{{ $t('message.user.phone') }}</p>
          <el-input v-model="form.phone" maxlength="15"
            :placeholder="$t('message.validator.input', { input: $t('message.user.phone') })" @input="handleInputPhone">
            <el-select v-model="form.areaCode" slot="prepend" filterable @change="handleAreaCodeChange">
              <el-option v-for="(item, index) in PHONE_AREAS" :key="index" :label="item.label"
                :value="item.value">{{ item.description }}</el-option>
            </el-select>
          </el-input>
        </div>
        <div v-if="showCaptcha">
          <p class="edit-form-label-title">{{ $t('message.user.captcha') }}</p>
          <div class="phone-captcha-box">
            <el-input class="captcha-input" maxlength="6" v-model="form.captcha"
              :placeholder="$t('message.validator.input', { input: $t('message.user.captcha') })"></el-input>
            <div class="margin-left-10">
              <el-button v-loading="requestingCode" class="btn-captcha" @click="sendCaptcha">{{ captchaLeftTime > 0 ?
                `${captchaLeftTime}s` : $t('message.user.sendCaptcha')}}</el-button>
            </div>
          </div>
        </div>
      </template>
    </validation-modal>
    <operator-add :visible="showAddDrawer" @close="showAddDrawer = false" @refresh="refreshTable"></operator-add>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getDictionary } from '@/api/common/index';
import { PHONE_AREAS } from '@/api/common/phone-area.js';
import validationModal from '@/components/modal/base-modal/validation-modal.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips.js';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { REQUIRED, EMAIL, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH } from '@/components/validation/tool/validator';
import { getOperatorList, updateOperator, resetPassword, getPhoneCaptcha } from '@/views/account/permission/api/operator';
import { getRoleNames, getRoleDetail } from '@/views/account/permission/api/role';
import OperatorAdd from '@/views/account/permission/operator/add/index.vue';
// import PermissionPopover from '@/views/account/permission/permission-popover/index.vue';

export default {
  components: {
    CustomTable,
    SearchComponent,
    CustomMessage,
    validationModal,
    // PermissionPopover,
    OperatorAdd,
  },
  data() {
    return {
      searchCondition: [
        {
          key: 'roleId',
          name: 'message.permission.role',
          type: 'select',
          defValue: '',
          options: [],
          customOptions: {
            label: 'roleName',
            value: 'id',
          },
        },
        // {
        //   key: 'operatorName',
        //   name: 'message.permission.name',
        //   type: 'input',
        //   defValue: '',
        // },
        {
          key: 'operatorEmail',
          name: 'message.user.loginEmail',
          type: 'input',
          defValue: '',
        },
        {
          key: 'contactEmail',
          name: 'message.user.contactEmail',
          type: 'input',
          defValue: '',
        },
        {
          key: 'status',
          name: 'message.tableCommon.status',
          type: 'select',
          defValue: '',
          customOptions: {
            label: 'description',
            value: 'value',
          },
          options: [],
        },
      ],
      searchButtons: [
        {
          type: 'add',
          name: this.$t('message.permission.addOperator'),
          permissionCode: 'account:permission:operator:add',
          func: () => {
            this.showAddDrawer = true;
          },
        },
      ],
      tableCondition: [
        { // 姓名
          titleBar: { type: 'text', title: 'message.permission.name' },
          key: 'operatorName',
          type: 'text',
        },
        { // 角色
          titleBar: { type: 'text', title: 'message.permission.role', filterKey: 'roleId' },
          key: 'roleName',
          type: 'slot',
          itemWidth: 200,
        },
        { // 登录邮箱
          titleBar: { type: 'text', title: 'message.user.loginEmail', filterKey: 'operatorEmail' },
          key: 'operatorEmail',
          type: 'text',
        },
        { // 联系邮箱
          titleBar: { type: 'text', title: 'message.user.contactEmail', filterKey: 'contactEmail' },
          key: 'contactEmail',
          type: 'text',
          textFunc: (data) => data.contactEmail ? data.contactEmail : '--',
        },
        { // 手机号
          titleBar: { type: 'text', title: 'message.user.phone', filterKey: 'operatorPhoneNumber' },
          key: 'operatorPhoneNumber',
          type: 'text',
          textFunc: (data) => {
            if (!data.operatorPhoneNumber) {
              return '--';
            }
            return `${data.areaCode || ''} ${data.operatorPhoneNumber}`;
          },
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status', filterKey: 'status' },
          key: 'statusName',
          itemWidth: 100,
          isInternationalization: true,
          type: 'tag',
          tagTypeFunc: (data) => {
            if (`${data.status}` === '1') {
              return 'success';
            } else if (`${data.status}` === '2') {
              return 'danger';
            }
            return 'info';
          },
        },
        { // 操作
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'buttons',
          type: 'operations',
          subTableDisplays: [
            { // 编辑
              type: 'text_button',
              permissionCode: 'account:permission:operator:edit',
              textFunc: () => 'message.tableCommon.edit',
              isDisplayFunc: (data) => !data.isAdmin,
              func: (data) => {
                this.handleEditModalClose();
                this.$refs.editOperatorModal.openModalAndCallBack((form) => {
                  if (this.showPhoneNumber) {
                    this.showCaptcha = !data.operatorPhoneNumber;
                    this.originalPhone = data.operatorPhoneNumber;
                    this.originalAreaCode = data.areaCode;
                    this.form.phone = data.operatorPhoneNumber;
                    if (data.areaCode) {
                      this.form.areaCode = data.areaCode;
                    }
                    this.form.captcha = '';
                  }
                  form.assignmentFormValue({ ...data });
                });
              },
            },
            { //  启用/禁用
              type: 'text_button',
              permissionCode: 'account:permission:operator:updateStatus',
              textFunc: (row) => {
                if (row.status === '1') {
                  return 'message.common.disable';
                }
                return 'message.common.enable';
              },
              isDisplayFunc: (data) => !data.isAdmin,
              func: (data) => {
                let message = `${this.$t('message.permission.enableOperatorConfirm')}?`;
                let status = '1';
                if (data.status === '1') {
                  message = `${this.$t('message.permission.disableOperatorConfirm')}?`;
                  status = '2';
                }
                // 确认框
                this.$refs.customMessage.openHttpModal({
                  titleHtml: this.$t('message.common.prompt'),
                  contentHtml: message,
                  httpFunction: this.updateOperator,
                  params: {
                    ...data,
                    operatorId: data.operatorId,
                    operatorEmail: data.operatorEmail,
                    contactEmail: data.contactEmail,
                    roleId: data.roleId,
                    areaCode: data.areaCode,
                    operatorPhoneNumber: data.operatorPhoneNumber,
                    status,
                  },
                  successFunction: this.refreshTable,
                }, 'warn');
              },
            },
            { // 重置密码
              type: 'text_button',
              permissionCode: 'account:permission:operator:resetPassword',
              textFunc: () => 'message.permission.resetPassword',
              isDisplayFunc: (data) => !data.isAdmin,
              func: (data) => {
                this.resetPasswordCondition[0].defValue = data.operatorEmail;
                this.resetPasswordCondition[1].defValue = data.operatorId;
                this.$refs.resetPasswordModal.openModal();
              },
            },
          ],
        },
      ],
      resetPasswordCondition: [
        {
          key: 'loginId',
          defValue: '',
          type: 'hidden',
        },
        {
          key: 'operatorId',
          defValue: '',
          type: 'hidden',
        },
        {
          key: 'password',
          name: 'message.user.newPasword',
          type: 'password',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.newPasword').toLowerCase() }),
        },
        {
          key: 'passwordRepeat',
          name: 'message.permission.passwordConfirm',
          type: 'password',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.permission.passwordConfirm').toLowerCase() }),
          validator: (rule, value, callback) => {
            if (value !== this.$refs.resetPasswordModal.getForm().$refs.appForm.model.password) {
              callback(new Error(this.$t('message.validator.passwordConfirm')));
            }
            callback();
          },
        },
      ],
      editOperatorCondition: [{
        key: 'operatorId',
        type: 'hidden',
      }, {
        key: 'operatorName',
        name: 'message.permission.name',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.name',
        rule: [REQUIRED],
      }, {
        key: 'contactEmail',
        name: 'message.user.contactEmail',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.user.contactEmail',
        rule: [REQUIRED, EMAIL],
      }, {
        key: 'roleId',
        name: 'message.permission.role',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.role',
        rule: [REQUIRED],
        option: {
          label: 'roleName',
          value: 'id',
        },
      }, {
        key: 'chargebackNotify',
        name: 'message.permission.receiveEmail',
        type: 'checkbox',
        placeholder: 'message.status.refuse',
        defValue: false,
      }, {
        key: 'status',
        name: 'message.permission.status',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: 'message.permission.status',
        rule: [REQUIRED],
        option: {
          label: 'description',
          value: 'value',
        },
      }],
      permissionMap: {},
      permissionInfo: {},
      showAddDrawer: false,
      form: {
        phone: '',
        areaCode: '+44',
        captcha: '',
      },
      captchaLeftTime: 0,
      requestingCode: false,
      showCaptcha: false,
      showPhoneNumber: false,
      PHONE_AREAS,
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  created() {
    if (this.app.userLogin.businessType === '0' || this.app.userLogin.isAggregateMerchant) {
      this.showPhoneNumber = true;
    }
    getRoleNames().then((res) => {
      const list = [
        ...res,
      ];
      this.searchCondition[0].options = list;
      this.editOperatorCondition[3].options = list;
    }).catch(() => ({}));
    getDictionary(['COMMON_STATUS']).then((res) => {
      this.searchCondition[3].options = res.COMMON_STATUS;
      this.editOperatorCondition[5].options = res.COMMON_STATUS;
    }).catch(() => ({}));
    if (this.$route.query.action === 'add') {
      this.showAddDrawer = true;
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
    this.captchaLeftTime = 0;
  },
  methods: {
    getOperatorList,
    updateOperator,
    resetPassword,
    refreshTable() {
      this.$refs.table.refreshTable();
    },
    handleEditModalClose() {
      console.log('handleEditModalClose');
      this.timer && clearTimeout(this.timer);
      this.captchaLeftTime = 0;
    },
    async onUpdateOperator(params) {
      const data = {
        ...params,
      };
      if (this.showPhoneNumber) {
        if (!this.form.phone) {
          ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.phone') }));
          return Promise.reject(new Error());
        }
        if (this.form.areaCode === '+86') { // 中国大陆
          if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
            ShowWarningMessage(this.$t('message.validator.inputPhone'));
            return Promise.reject(new Error());
          }
        }
        if (this.form.areaCode === '+852') { // 中国香港
          if (!(/([6|9])\d{7}$/.test(this.form.phone))) {
            ShowWarningMessage(this.$t('message.validator.inputPhone'));
            return Promise.reject(new Error());
          }
        }

        if (this.showCaptcha && !this.form.captcha) {
          ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.captcha') }));
          return Promise.reject(new Error());
        }
        data.operatorPhoneNumber = this.form.phone;
        data.areaCode = this.form.areaCode;
        if (this.showCaptcha) {
          data.captcha = this.form.captcha;
        }
      }

      await updateOperator(data);
      this.timer && clearTimeout(this.timer);
      this.captchaLeftTime = 0;
    },
    editSuccessHandler() {
      this.refreshTable();
    },
    handleInputPhone(value) {
      const v = value.match(/^\d*(\d{0,10})/g)[0];
      this.form.phone = v;
      if (this.form.phone !== this.originalPhone || this.form.areaCode !== this.originalAreaCode) {
        this.showCaptcha = true;
        return;
      }
      this.showCaptcha = false;
    },
    handleAreaCodeChange() {
      if (this.form.phone !== this.originalPhone || this.form.areaCode !== this.originalAreaCode) {
        this.showCaptcha = true;
        return;
      }
      this.showCaptcha = false;
    },
    async handleShowPermission(roleId) {
      this.permissionInfo = {};
      if (!this.permissionMap[roleId]) {
        this.permissionMap[roleId] = await getRoleDetail(roleId);
      }
      this.permissionInfo = this.permissionMap[roleId];
    },
    async sendCaptcha() {
      if (this.captchaLeftTime > 0 || this.requestingCode) {
        return;
      }
      if (!this.form.phone) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.phone') }));
        return;
      }
      if (this.form.areaCode === '+86') { // 中国大陆
        if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
          ShowWarningMessage(this.$t('message.validator.inputPhone'));
          return;
        }
      }

      if (this.form.areaCode === '+852') { // 中国香港
        if (!(/([6|9])\d{7}$/.test(this.form.phone))) {
          ShowWarningMessage(this.$t('message.validator.inputPhone'));
          return;
        }
      }

      this.requestingCode = true;
      try {
        const lang = this.$store.getters.app.currentLan;
        const language = lang === 'zh-cn' ? 'zh' : lang;
        await getPhoneCaptcha({
          phone: this.form.phone.trim(),
          areaCode: this.form.areaCode,
          language,
        });
        if (this.timer) {
          clearInterval(this.timer);
        }

        this.captchaLeftTime = 59;
        this.timer = setInterval(() => {
          this.captchaLeftTime -= 1;
          if (this.captchaLeftTime <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (err) {

      }
      this.requestingCode = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.role-name-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 180px;
  padding-right: 20px !important;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;

  .icon-wenhao {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.permission-popover {
  min-width: 364px;
  padding: 25px !important;
  padding-top: 8px !important;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.edit-form-label-title {
  color: #264373;
  line-height: 0.64rem;
  padding-bottom: 0;
  font-weight: 800;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
}

.phone-captcha-box {
  display: flex;
  align-items: center;
}
</style>
